import { render, staticRenderFns } from "./FaqAccordion.vue?vue&type=template&id=61fe2c7a"
import script from "./FaqAccordion.vue?vue&type=script&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports